import { Row } from "antd";
import styled from "styled-components";

export const ChatInputWrapper = styled(Row)<{ $isDisabled: boolean }>`
  .send-icon-wrapper {
    height: 32px;
    filter: ${(props) => (props.$isDisabled ? "grayscale(80%)" : "none")};

    .ant-btn {
      height: fit-content;
      width: fit-content;
    }
  }
`;

export const ChatMessageWrapper = styled(Row)<{ $isContractorsChat: boolean }>`
  > .message-main-block {
    max-width: calc(
      100% - ${(props) => (props.$isContractorsChat ? "32px" : "36px")}
    );

    .ant-space-item,
    .message-header {
      max-width: 100%;
    }

    .message-header > .ant-col:first-child {
      max-width: ${(props) => (props.$isContractorsChat ? "224px" : "352px")};
    }
  }

  .ant-typography {
    color: ${"#595959"};
  }

  .message-gray-text {
    color: ${"#bfbfbf"};
  }

  .message-author {
    font-weight: 600;
  }

  .message-role {
    line-height: 16px;
    font-size: 12px;
  }

  .ant-typography.message-text {
    margin-top: 4px;
    font-weight: 500;
  }
`;

export const ChatHistoryWrapper = styled.div`
  position: relative;
  height: 100%;

  .chat-loader-wrapper > div {
    background-color: inherit;
  }

  .message-element > .ant-space-item > .ant-row > .ant-tag {
    padding: 0 12px;
    margin: 0;
    height: 20px;
    line-height: 20px;
    border-radius: 12px;
  }

  .message-element:not(:first-child) {
    margin-top: 20px;
  }
`;

export const ScrollableChatWrapper = styled.div<{ $maxHeight: number }>`
  overflow-x: hidden;
  overflow-y: auto;
  max-height: ${(props) => props.$maxHeight}px;
`;
